<div class="root-md">
  <p class="title-md">Your Previous Month at EasyEquities</p>
</div>
